/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useForm } from "react-hook-form";
import utils from '../utils/utils.functions';
import notification from './notification.component';

const EmailGuide = ({ onClose, codigo, email, show }) => {

  const { register, handleSubmit, errors, reset } = useForm();
  const [proceso, setProceso] = useState(false);
  const onSubmit = data => {
    enviarCorreo(data);
  };

  useEffect(() => {
    reset({
      correo_guia_envio: email,
      codigo_guia: codigo,
    });
  },[show]);

  const enviarCorreo = (data) => {
    setProceso(true);
    utils.enviarGuiaCorreo(data).then((response) => {
      if (response.status === 200) {
        if (response.data.envio_guia) {
          notification.success();
        } else {
          notification.warning('Intentelo nuevamente')
        }
        setProceso(false);
      }
    })
  }

  return (
    <div className="mb-3">
      <form onSubmit={handleSubmit(onSubmit)}>
      <div className="grupo-input">
        <small>Email donde se enviara la guia</small>
        <div className="d-flex">
          <input type="text"
            className={`form-control input-border ${errors.correo_guia_envio && "is-invalid"}`}
            name="correo_guia_envio"
            ref={register({ required: true })}
            disabled={proceso}
            />
          <input type="hidden" name="codigo_guia" ref={register({ required: true })}/>
          <button type="submit" className="btnx btnx-warn" disabled={proceso}>Enviar</button>
        </div>
        <div style={{ height: 45 }}>
          {proceso ? 'Espere mientras se envia el correo' : ''}
        </div>
        <button type="button" onClick={() => onClose()} className="btnx btnx-warn" >Cancelar</button>
      </div>
      </form>
    </div>
  )
}

export default EmailGuide;